export * from './Tag';
export { default } from './Tag';
//# sourceMappingURL=index.js.map